/**
 * Route for `igaming-wager-events-granular`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingWagerEventsGranularPage } from "../features/igaming-wager-events-granular/IgamingWagerEventsGranularPage";

export const igamingWagerEventsGranularRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-wager-events-granular",
	component: IgamingWagerEventsGranularPage,
});

export default igamingWagerEventsGranularRoute;
